// extracted by mini-css-extract-plugin
export var attachmentContainer = "_rw-0";
export var fileList = "_rw-2";
export var removeFileButton = "_rw-1";